// Peças da tela Talk.ai (/prompts) que não vêm de campaignPageStyles —
// mockup "Tela Aeros Dark - Talk.ai e Modais": faixa de KPI, ladrilho do
// agente, etiqueta de voz e a nota do rodapé.
import { makeStyles, alpha } from "@material-ui/core/styles";
import { stateText } from "../../styles/aerosTokens";

const usePromptPageStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  const borderCard = isLight ? theme.palette.divider : "rgba(255,255,255,0.07)";

  return {
    pageSubtitle: {
      fontSize: 12,
      color: theme.palette.text.secondary,
      lineHeight: 1.3,
      marginTop: 1,
    },
    kpiGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(4,minmax(0,1fr))",
      gap: 14,
      marginBottom: 18,
      [theme.breakpoints.down("sm")]: { gridTemplateColumns: "minmax(0,1fr)" },
    },
    kpiCard: {
      backgroundColor: theme.palette.aeros.surface,
      border: `1px solid ${borderCard}`,
      borderRadius: 14,
      padding: "14px 16px",
      display: "flex",
      alignItems: "center",
      gap: 12,
    },
    kpiTile: {
      width: 38,
      height: 38,
      borderRadius: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: "none",
      backgroundColor: alpha(theme.palette.primary.main, 0.14),
      color: stateText(theme, "#C08BFF", "purple"),
      "& .MuiSvgIcon-root": { fontSize: 20 },
    },
    kpiValue: {
      fontSize: 20,
      fontWeight: 700,
      letterSpacing: "-0.02em",
      fontVariantNumeric: "tabular-nums",
      lineHeight: 1.1,
      color: theme.palette.text.primary,
    },
    kpiLabel: { fontSize: 11.5, color: theme.palette.text.secondary, marginTop: 2 },

    // Ladrilho do agente na coluna "Agente" (cor/ícone por id).
    agentTile: {
      width: 36,
      height: 36,
      borderRadius: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: "none",
      "& .MuiSvgIcon-root": { fontSize: 19 },
    },
    voiceTag: {
      display: "inline-flex",
      alignItems: "center",
      gap: 3,
      color: stateText(theme, "#C08BFF", "purple"),
      "& .MuiSvgIcon-root": { fontSize: 12 },
    },
    modelCell: {
      fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
      fontSize: 12,
      color: theme.palette.text.secondary,
    },
    tokensCell: { fontSize: 13, fontVariantNumeric: "tabular-nums" },
    tableScroll: { overflowX: "auto", ...theme.scrollbarStylesSoft },
    // Soma mínima das seis colunas; abaixo disso o wrapper rola.
    tableInner: { minWidth: 860 },
    footerNote: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      fontSize: 11.5,
      color: theme.palette.aeros.textTertiary,
      marginTop: 18,
      "& .MuiSvgIcon-root": { fontSize: 14 },
    },
  };
});

export default usePromptPageStyles;
